import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['message'];

  static values = {
    userUuid: String,
  };

  connect() {
    if (this.messageTargets.length > 0) {
      this.messageTargets[0].scrollIntoView();
    }
  }

  messageTargetConnected(element) {
    const deletionForm = element.querySelector('.message-deletion-form');

    if (deletionForm !== null) {
      const { authorUuid } = element.dataset;

      if (authorUuid !== this.userUuidValue) {
        deletionForm.remove();
      }
    }

    element.scrollIntoView();
  }
}
